import * as angular from "angular";
import { ProductService } from "../services/product.service";

export class ProductDataProvider {
    public products: any;
    private service: ProductService;
    private productsPromise: any;
    private $q: any;

    constructor($q: any, ProductService: ProductService) {
        this.service = ProductService;
        this.$q = $q;

        this.products = null;
        this.productsPromise = null;
    }

    all() {
        if (this.products !== null) {
            return this.$q.resolve(this.products);
        } else if (this.productsPromise) {
            //Has been called already and has not resolved yet.
            return this.productsPromise;
        } else {
            const deferred = this.$q.defer();

            this.service.all().then(
                (response) => {
                    let json = response["data"];
                    this.products = json.data;
                    deferred.resolve(this.products);
                },
                (error) => {
                    this.products = [];
                    deferred.reject(error);
                }
            );

            this.productsPromise = deferred.promise;
            return this.productsPromise;
        }
    }

    getUserLicenseProduct(campaign, products) {
        let key = "super_user_license";

        return products.find(
            (product: any) =>
                product.key === key && product.region === campaign.cpcountry
        );
    }

    previewInvoice(stripeid: string, quantity: number) {
        const deferred = this.$q.defer();

        this.service.previewInvoice({ stripeid, quantity }).then(
            (response) => {
                let json = response["data"];
                deferred.resolve(json.data);
            },
            (error) => deferred.reject(error)
        );

        this.productsPromise = deferred.promise;
        return this.productsPromise;
    }

    previewPlanChange(
        stripeid,
        couponid,
        removeCoupon,
        conversionType?: string
    ) {
        const deferred = this.$q.defer();

        this.service
            .previewPlanChange({
                stripeid: stripeid,
                couponid: couponid,
                removeCoupon: removeCoupon,
                conversionType: conversionType,
            })
            .then(
                (response) => {
                    let json = response["data"];
                    deferred.resolve(json.data);
                },
                (error) => {
                    deferred.reject(error);
                }
            );

        this.productsPromise = deferred.promise;
        return this.productsPromise;
    }

    previewNextInvoice(couponid, removeCoupon) {
        const deferred = this.$q.defer();

        this.service
            .previewNextInvoice({
                couponid: couponid,
                removeCoupon: removeCoupon,
            })
            .then(
                (response) => {
                    let json = response["data"];
                    deferred.resolve(json.data);
                },
                (error) => deferred.reject(error)
            );

        this.productsPromise = deferred.promise;
        return this.productsPromise;
    }

    couponDescription(coupon) {
        let currency = "$";

        if (coupon.currency == "eur") {
            currency = "€";
        } else if (coupon.currency == "gbp") {
            currency = "£";
        }

        let string = "";
        if (coupon.amount_off) {
            string = currency + coupon.amount_off / 100;
        } else if (coupon.percent_off) {
            string = coupon.percent_off + "%";
        }

        string += " off ";

        if (coupon.duration == "forever") {
            return string + " forever";
        } else if (coupon.duration == "repeating") {
            return string + " for " + coupon.duration_in_months + " months";
        }

        return string;
    }

    previewFirstInvoice(stripeid, couponid, removeCoupon) {
        const deferred = this.$q.defer();

        this.service
            .previewFirstInvoice({
                stripeid: stripeid,
                couponid: couponid,
                removeCoupon: removeCoupon,
            })
            .then(
                (response) => {
                    let json = response["data"];
                    deferred.resolve(json.data);
                },
                (error) => deferred.reject(error)
            );

        this.productsPromise = deferred.promise;
        return this.productsPromise;
    }

    changeQuantity(product, quantity) {
        const deferred = this.$q.defer();

        this.service
            .changeQuantity({ product: product, quantity: quantity })
            .then(
                (response) => {
                    let json = response["data"];
                    deferred.resolve(json);
                },
                (error) => deferred.reject(error)
            );

        this.productsPromise = deferred.promise;
        return this.productsPromise;
    }
}

angular
    .module("vcDataProvider")
    .service("ProductDataProvider", ProductDataProvider);
